module.exports = {"id":"200911","name":"Bogdan Stancu","rating":"73","photo":"./data/images/photos/0/200911.png","club":{"name":"Bursaspor","logo":"./data/images/clubs/Bursaspor.png"},"positions":["BU","MG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BogdanStancu0.json
// module id = 615
// module chunks = 0